import { useQuery } from '@tanstack/react-query';
import type { ContentSuggestionRequestResponse } from '@//app/api/suggestions/content';
import { useApiBaseUrl } from '@//providers/MarketSettingsProvider';
import { httpClientGetJson } from '../httpClient';

const useContentSuggestions = (q: string) => {
  const apiBaseUrl = useApiBaseUrl();
  const query = useQuery<ContentSuggestionRequestResponse>({
    queryKey: ['suggestionsContent', q],
    queryFn: async ({ signal }) => {
      const url = `${apiBaseUrl}/api/suggestions/content?q=${q}`;
      return await httpClientGetJson<ContentSuggestionRequestResponse>(url, {
        signal,
      });
    },
    enabled: !!q,
  });

  return query;
};

export default useContentSuggestions;
